import React from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqData } from '../data/mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-16 sm:py-28 bg-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-20">
          <span className="inline-block px-4 sm:px-5 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-500 text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-6">
            Questions Fréquentes
          </span>
          <h2 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-8 px-2">
            Tout savoir sur le <span className="text-amber-500">Retour Affectif</span>
          </h2>
          <p className="text-gray-300 text-base sm:text-xl max-w-3xl mx-auto leading-relaxed px-2">
            Le grand marabout africain répond à vos questions les plus fréquentes sur les rituels de retour affectif et la magie amoureuse.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-3 sm:space-y-5">
          {faqData.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-gray-900/50 border border-amber-500/10 rounded-xl sm:rounded-2xl px-4 sm:px-8 data-[state=open]:border-amber-500/30 transition-all duration-300"
            >
              <AccordionTrigger className="text-left py-4 sm:py-7 hover:no-underline group">
                <div className="flex items-start space-x-3 sm:space-x-5">
                  <HelpCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 mt-0.5 flex-shrink-0" />
                  <span className="text-white font-semibold text-base sm:text-xl group-hover:text-amber-500 transition-colors pr-4 sm:pr-6 leading-relaxed text-left">
                    {faq.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-4 sm:pb-8 pl-8 sm:pl-11">
                <p className="text-gray-300 text-sm sm:text-lg leading-relaxed">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Bottom CTA */}
        <div className="mt-10 sm:mt-16 text-center px-2">
          <p className="text-gray-300 text-sm sm:text-lg mb-2 sm:mb-3">Vous avez d'autres questions ?</p>
          <p className="text-amber-500 font-semibold text-base sm:text-xl">Contactez le marabout directement pour une consultation personnalisée</p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
